import { $selectedRibbonBar, ribbonBars } from './RibbonBar';
import { RibbonTabs } from './RibbonTabs';
import { useStore } from '@nanostores/react';

export function Ribbon() {
  const selected = useStore($selectedRibbonBar);
  const RibbonBar = ribbonBars[selected];

  return (
    <div className="flex flex-col justify-between">
      <RibbonTabs />
      <RibbonBar />
    </div>
  );
}
